import { DeleteOutlined, MenuOutlined,PlusOutlined } from '@ant-design/icons';
import { Button, Card,Form, Input, List, message, notification, PageHeader, Row, Spin } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useEffect, useState } from 'react';
import { DragDropContext, Draggable,Droppable } from 'react-beautiful-dnd';

import { GetWelcomeMessages, UpdateWelcomeMessagesReq } from '../../../services/api';

const { TextArea } = Input;

export const UpdateWelcomeMessages: React.FC<any> = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [welcomeMessages, setWelcomeMessages] = useState<string[]>([]);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchWelcomeMessages();
  }, []);

  // Welcome messages geldiğinde form'u güncelle
  useEffect(() => {
    form.setFieldsValue({ messages: welcomeMessages });
  }, [welcomeMessages, form]);

  const fetchWelcomeMessages = async () => {
    setLoading(true);
    try {
      GetWelcomeMessages()
        .then((result) => {
          const messages = result.data || [];
          setWelcomeMessages(messages);
          // Form'u yeni data ile güncelle
          form.setFieldsValue({ messages: messages });
          setLoading(false);
        })
        .catch((error) => {
          // Eğer setting bulunamazsa (404), boş array ile başla
          if (error.response && error.response.status === 404) {
            setWelcomeMessages([]);
            form.setFieldsValue({ messages: [] });
          } else {
            notification.error({
              message: 'Service Error',
              description:
                error.message ||
                'Something unexpected happen. Api returned error. See console for details.',
            });
            console.error(error);
          }
          setLoading(false);
        });
    } catch (e) {
      setLoading(false);
    }
  };

  const handleDragEnd = (result: any) => {
    if (!result.destination) {
      return;
    }

    const formValues = form.getFieldsValue();
    const items = Array.from(formValues.messages) as string[];
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    form.setFieldsValue({ messages: items });
    setWelcomeMessages(items);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const filteredMessages = values.messages.filter((msg: string) => msg && msg.trim() !== '');

      UpdateWelcomeMessagesReq(filteredMessages)
        .then((result) => {
          notification.success({
            message: 'Success',
            description: 'Welcome messages updated successfully',
          });
          setWelcomeMessages(filteredMessages);
        })
        .catch((error) => {
          notification.error({
            message: 'Service Error',
            description:
              error.message ||
              'Something unexpected happen. Api returned error. See console for details.',
          });
          console.error(error);
        });
    } catch (e) {
      console.error('Validation failed:', e);
    }
  };

  return (
    <div>
      <PageHeader
        className="site-page-header"
        onBack={() => null}
        title="Welcome Messages"
        subTitle="Manage the welcome messages shown to new users (drag to reorder)"
      />
      <Content style={{ margin: '0px 16px 0', overflow: 'initial' }}>
        <div
          className="site-layout-background"
          style={{ padding: 24 }}
        >
          <Row style={{ marginBottom: 24 }}>
            <div style={{ width: '100%' }}>
              <Spin spinning={loading}>
                <Form
                  form={form}
                  initialValues={{ messages: welcomeMessages }}
                  onFinish={handleSave}
                  layout="vertical"
                >
                  <Form.List name="messages">
                    {(fields, { add, remove }) => (
                      <>
                        <DragDropContext onDragEnd={handleDragEnd}>
                          <Droppable droppableId="messages">
                            {(provided) => (
                              <div {...provided.droppableProps} ref={provided.innerRef}>
                                {fields.map(({ key, name, ...restField }, index) => (
                                  <Draggable key={key} draggableId={key.toString()} index={index}>
                                    {(provided, snapshot) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                      >
                                        <Card
                                          size="small"
                                          title={
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                              <div
                                                {...provided.dragHandleProps}
                                                style={{
                                                  marginRight: 8,
                                                  cursor: 'grab',
                                                  color: '#666'
                                                }}
                                              >
                                                <MenuOutlined />
                                              </div>
                                              <span>Message {index + 1}</span>
                                            </div>
                                          }
                                          extra={
                                            fields.length > 1 ? (
                                              <Button
                                                type="text"
                                                danger
                                                icon={<DeleteOutlined />}
                                                onClick={() => remove(name)}
                                              />
                                            ) : null
                                          }
                                          style={{
                                            marginBottom: 16,
                                            backgroundColor: snapshot.isDragging ? '#f0f0f0' : 'white',
                                            transform: snapshot.isDragging ? 'rotate(2deg)' : 'none'
                                          }}
                                        >
                                          <Form.Item
                                            {...restField}
                                            name={name}
                                            rules={[
                                              { required: true, message: 'Please input welcome message!' },
                                              { max: 2000, message: 'Message is too long!' }
                                            ]}
                                          >
                                            <TextArea
                                              rows={4}
                                              placeholder="Enter welcome message..."
                                              showCount
                                              maxLength={2000}
                                            />
                                          </Form.Item>
                                        </Card>
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>

                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            Add Welcome Message
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>

                  <Form.Item style={{ marginTop: 24 }}>
                    <Button type="primary" htmlType="submit" size="large">
                      Save Welcome Messages
                    </Button>
                  </Form.Item>
                </Form>
              </Spin>
            </div>
          </Row>
        </div>
      </Content>
    </div>
  );
};
